import { useContext } from 'react';

import { AppContext } from '../../context/app/app.context';
import { IAppContext } from '../../context/app/app.types';

export const useAppContext = (): IAppContext => useContext(AppContext);
